import { GoogleAuthProvider,FacebookAuthProvider } from "firebase/auth";

export const googleAuthProvider = new GoogleAuthProvider();

export const facebookAuthProvider = new FacebookAuthProvider()